import React, { useEffect, useState } from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useApiClient } from "../../../api";
import { CreateStudentDialog } from "../components/CreateStudentDialog";
import { Box, Button, Typography } from "@mui/material";
import { Add, Groups3 } from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import { BulkAssignStudentDialog } from "../components/BulkAssignStudentDialog";
import { FruitifyStudentSearch } from "../components/FruitifyStudentSearch";

const StudentsOverview = () => {
  const ApiClient = useApiClient();
  const [open, setOpen] = useState(false);
  const [bulkAssignOpen, setBulkAssignOpen] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [schoolClasses, setSchoolClasses] = useState([]);

  const [students, setStudents] = useState([]);
  const [schools, setSchools] = useState([]);
  const [yearGroups, setYearGroups] = useState([]);

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await ApiClient.schools.getStudents();
        if (response) {
          setStudents(response.students);
          setSchools(response.schools);
          setSchoolClasses(response.possibleClasses);
          setYearGroups(response.yearGroups);
        }
      } catch (error) {
        console.error("Failed to fetch schools", error);
      }
    };
    fetchStudents();
  }, []);

  const handleStudentCheckboxClicked = (studentId, checked) => {
    setSelectedStudents((prevSelected) => {
      if (checked) {
        // Add student if not already in the array
        if (!prevSelected.includes(studentId)) {
          return [...prevSelected, studentId];
        }
        return prevSelected;
      } else {
        // Remove student if it exists
        return prevSelected.filter((id) => id !== studentId);
      }
    });
  };

  const handleOpen = () => setOpen(true);

  return (
    <FruitifyContainer>
      <CreateStudentDialog
        open={open}
        setOpen={setOpen}
        schools={schools}
        yearGroups={yearGroups}
      />
      <BulkAssignStudentDialog
        open={bulkAssignOpen}
        setOpen={setBulkAssignOpen}
        schoolClasses={schoolClasses}
        students={selectedStudents}
      />
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        gap={2}
        mb={2}
      >
        <Typography variant="h3" fontWeight="bold">
          Students
        </Typography>
        <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
          <Button
            disabled={selectedStudents.length === 0}
            variant="contained"
            endIcon={<Groups3 />}
            onClick={() => setBulkAssignOpen(true)}
          >
            Assign To Class
          </Button>
          <Button variant="contained" endIcon={<Add />} onClick={handleOpen}>
            Add Student
          </Button>
        </Stack>
      </Box>
      <FruitifyStudentSearch
        students={students}
        onStudentCheckBoxClick={handleStudentCheckboxClicked}
        selectedStudents={selectedStudents}
      />
    </FruitifyContainer>
  );
};

export default StudentsOverview;
